const currency = num =>
  num
    ? Number(num).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      })
    : '$0.00';

export default currency;
